import { FaChevronLeft } from "react-icons/fa";

const SideToggleButton = ({ sideToggle, handleSideToggle }) => {
  return (
    <button
      className=" group lg:flex h-[62px] hidden  hover:bg-sidebarHeader  bg-sidebarHeader/70 w-full items-center justify-end px-5 shadow-2xl"
      onClick={handleSideToggle}
    >
      <FaChevronLeft
        className={` group-hover:text-primary w-5 h-5 transition-all duration-300 ease-out ${
          sideToggle && "rotate-180"
        }`}
      />
    </button>
  );
};

export default SideToggleButton;
